import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Success from "components/success/index";

import mailSent from "assets/images/success/mailSent.svg";

import "./forgotPassword.scss";
import useScreenMobile from "hooks/useScreen";
import Button from "components/Button/index";
import { ManageUser as MU } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: ""
  });

  const [errors, setErrors] = useState({});

  const [isFormValid, setIsFormValid] = useState(false);

  const [isMailSent, setMailSent] = useState(false);
  // eslint-disable-next-line
  const isMobile = useScreenMobile({ size: 568 });

  useEffect(() => {
    setIsFormValid(checkFormValidity());
  }, [formData, errors]);

  // const [showpopup, setShowPopup] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    const error = validate(name, value);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: error });
  };

  const validate = (name, value) => {
    let error = "";

    if (name === "email") {
      if (!value) {
        error = "Email is required";
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = "Please enter the valid email id";
        }
      }
    }

    return error;
  };

  const showToast = useToast();
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailError = validate("email", formData.email);

    if (!emailError) {
      try {
        setLoading(true);
        await MU.resetPassword(formData.email);
        setMailSent(true);
      } catch (error) {
        setLoading(false);
        // console.error("creating error:", error);
        showToast(error.message, "error");
      }
    } else {
      setErrors({ email: emailError });
    }
  };

  const checkFormValidity = () => {
    return (
      Object.values(errors).every((error) => !error) &&
      // Object.values(formData).every((value) => value.trim() !== "")
      formData.email.trim() !== ""
    );
  };

  const handleOpenMail = () => {
    
    navigate("/signin");
  };

  return (
    <>
      {isMailSent ? (
        <Success
          title="Check your registered email to reset your password"
          titleWidth="75.7%"
          titleMobileWidth="100%"
          subTitle="An email has been sent to your registered address with a link to reset your password. Follow the instructions to create a new password securely. If Organization User asks Your Admin"
          subTitleWidth="85.2%"
          subTitleMobileWidth="100%"
          buttonText="Done"
          image={mailSent}
          imgWidth="80px"
          imgHeight="80px"
          onClick={handleOpenMail}
          // password={true}
          success={true}
        />
      ) : (
        <section
          className="forgotPassword"
          style={
            {
              // height: isMobile && isMailSent ? "126vh" : "",
              // padding: isMobile && isMailSent ? "unset" : ""
            }
          }
        >
          <div className="forgotPasswordContainer">
            <div className="textField">
              <h1 className="title">Forgot Password</h1>
              <p className="content">
                Enter your registered email address to reset your password.
                We&apos;ll send you a link to create a new password.
              </p>
            </div>
            <div className="emailField">
              <form onSubmit={handleSubmit}>
                <div className="field">
                  <label htmlFor="email" className="emailLabel">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className={`email ${errors.email ? "errorBorder" : ""}`}
                    placeholder="you@email.com"
                    onChange={handleChange}
                    value={formData.email}
                  />
                  {errors.email && <p className="errorMsg">{errors.email}</p>}
                </div>
                <div className="buttonContainer">
                  {/* <button
                    className={`button ${isFormValid ? "enabled" : "disabled"}`}
                  >
                    Continue
                  </button> */}
                  <Button
                  loading = {loading}
                    title=" Continue"
                    disabled={!isFormValid}
                    type="violet"
                  />
                </div>
              </form>
            </div>
          </div>
        </section>
      )}

      {/* {showpopup && (
        <Success
          title="Check your registered email to reset your password"
          titleWidth="75.7%"
          titleMobileWidth="100%"
          subTitle="An email has been sent to your registered address with a link to reset your password. Follow the instructions to create a new password securely"
          subTitleWidth="85.2%"
          subTitleMobileWidth="100%"
          buttonText="Check Mail"
          image={mailSent}
          imgWidth="80px"
          imgHeight="80px"
          onClick={handleOpenMail}
          password={true}
        />
      )} */}
    </>
  );
};

export default ForgotPassword;
